// extracted by mini-css-extract-plugin
module.exports = {"pageChanger":"F-page-changer-page-changer-XGRM9"};